import * as React from 'react';
import { Modal, Button } from 'antd';
import strings from '../../eyeguide-localization/strings.common';
import { Redirect } from 'react-router-dom';
import '../../css/UserAgreement.scss';
import LocalStorage from '../../service/localstorage';
import service from '../../service/apolloclient.service';

const logo = require('../../images/logo.svg');

interface IUserAgreementProps {
    isModalVisible: boolean;
    modalClosed: any;
}

interface IUserAgreementState {
    isModalVisible: boolean;
    toMain: boolean;
    tcTemplate: string;
}

export class UserAgreement extends React.Component<IUserAgreementProps, IUserAgreementState> {
    constructor(props: IUserAgreementProps) {
        super(props);
        this.state = {
            isModalVisible: this.props.isModalVisible,
            toMain: false,
            tcTemplate: ''
        };
    }

    componentWillReceiveProps(nextProps: any) {
        this.setState({
            isModalVisible: nextProps.isModalVisible
        });
    }

    render() {
        if (this.state.toMain === true) {
            this.setState({ isModalVisible: false });
            return ( <Redirect to="/dashboard" /> );
        }
        return (
            <Modal
                className="UserAgreement"
                title={<div className="container">
                            <div className="logoContainer"><img className="logo" src={logo} /></div>
                       </div>
                       }
                visible={this.state.isModalVisible}
                width={800}
                style={{ centered: true}}
                bodyStyle={{padding: 0 }}
                maskClosable={false}
                closable={false}
                footer={[
                    <Button 
                            key="Ok" 
                            type="primary"  
                            onClick={() => this.updateUserTC()}
                    >
                    {strings.lsAcceptTxt}
                    </Button>,
                    <Button 
                            key="cancel" 
                            type="danger"  
                            onClick={() => this.closeForm()}
                    >
                        {strings.lsDeclineTxt}
                    </Button>
                ]}
            >
                <div 
                    className="tccontent" 
                    /*Include the HTML Template for Terms and Conditions*/
                    dangerouslySetInnerHTML={{__html: this.state.tcTemplate}} 
                /> 
            </Modal>
        );
    }

    async componentDidMount() {
        let ser     = new service();
        let storage = new LocalStorage();
        let resp    = await ser.getTC(storage.getTemplateName()); // Pass the filename of tc template
        this.setState({ tcTemplate: resp.htmlcontent });
        console.log(this.state.tcTemplate);
    }

    private async updateUserTC() {
        let resp: string = '';
        let ser = new service();
        let storage = new LocalStorage();
        resp = await ser.updateUserTC(storage.getToken(), storage.getVersion(), storage.getUid());
        console.log('UserAgreement Response', resp);
        this.initializeLocalstorage(resp);
        this.setState({ toMain: true });

    }

    private closeForm() {
        window.location.href = '/login';
        this.setState({
            isModalVisible: false
        });
    }

    private initializeLocalstorage(res: any) {
        let storage = new LocalStorage();
        storage.setToken(res.token !== undefined ? res.token : '');   
        console.log('initializeLocalstorage', res);
    }

}


// WEBPACK FOOTER //
// ./src/components/login/UserAgreement.tsx